import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Presentation = _resolveComponent("Presentation")!
  const _component_Services = _resolveComponent("Services")!
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createBlock(_component_Container, { class: "home-template" }, {
    default: _withCtx(() => [
      _createVNode(_component_Header),
      _createVNode(_component_Presentation),
      _createVNode(_component_Services)
    ]),
    _: 1
  }))
}